import VueRouter from 'vue-router';

export default function (router: VueRouter, organisationId: string | null, deviceId: string | null) {
  deviceId
    ? router.push({
        name: 'Device',
        params: {
          deviceId: deviceId
        }
      })
    : router.push({
        name: 'NewDevice',
        params: {
          organisationId: organisationId!
        }
      });
}
